import angular from 'angular'

import './configs/active-user-config'
import './configs/debug-config'
import './configs/api-interceptor-config'

angular.module('webregister').config(function ($animateProvider: $TSFixMe) {
  // sale-body isn't actually animated. It's added here to prevent the animation of it's nested sale-list-item's during
  // the initial render / data load.
  $animateProvider.classNameFilter(
    /wr-transition-*|vd-quick-key-folder-view-container|sale-body|sale-list-item/
  )
})
